module.exports = __webpack_public_path__ + "media/images/whatsapp2-79a62cb21bce636fe5fec305c5f9bbd0.png";